import { render, staticRenderFns } from "./NewspaperPopupContent.vue?vue&type=template&id=42e03766&scoped=true&"
import script from "./NewspaperPopupContent.vue?vue&type=script&lang=js&"
export * from "./NewspaperPopupContent.vue?vue&type=script&lang=js&"
import style0 from "./NewspaperPopupContent.vue?vue&type=style&index=0&id=42e03766&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42e03766",
  null
  
)

export default component.exports